export default "__VITE_ASSET__3EANrupy__"